import { useMemo } from 'react';
import { DEFAULT_BACKGROUND_CONFIG } from '@atlassian/jira-custom-theme-constants/src/constants.tsx';
import type { ProjectTheme } from '@atlassian/jira-custom-theme-constants/src/types.tsx';
// eslint-disable-next-line camelcase
import { DEPRECATED_DO_NOT_USE_projectDetailsResource } from '@atlassian/jira-router-resources-business-project-details/src/index.tsx';
import { useResource } from '@atlassian/react-resource-router';

/**
 * @deprecated delete when cleaning up jira_theming_relay_migration
 */
export const useProjectTheme = (): ProjectTheme | null => {
	const { data } = useResource(DEPRECATED_DO_NOT_USE_projectDetailsResource);

	return useMemo(() => {
		if (data != null) {
			const entityId = `project/${data.currentProject?.id}`;

			const themeSetting = data.themeSetting ?? {
				type: 'color',
				value: DEFAULT_BACKGROUND_CONFIG.name,
			};

			return {
				themeSetting,
				entityId,
			};
		}

		return null;
	}, [data]);
};
